export default __webpack_public_path__ + "static/media/tracking.17fa1877.svg";